import FilterIcon from "@mui/icons-material/FilterListRounded";
import { Stack } from "@mui/material";
import type { Field, ObjectFilter, SelectOption } from "../../api/types/objectTypes";
import ObjectFilterDescriptionText from "./ObjectFilterDescriptionText";

interface Props {
  filter: ObjectFilter;
  availableFields: Field[];
  selectOptions?: SelectOption[];
  objectTypePrefix?: string;
  startLabel: string;
}

const ObjectFilterDescription = ({ filter, availableFields, selectOptions, objectTypePrefix, startLabel }: Props) => {
  const resolvedName = availableFields.find((f) => f.id === filter.fieldId)?.name || filter.fieldId;
  const fieldName = objectTypePrefix ? `${objectTypePrefix}.${resolvedName}` : resolvedName;

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <FilterIcon color="action" />
      <ObjectFilterDescriptionText
        fieldName={fieldName}
        filter={filter}
        selectOptions={selectOptions}
        startLabel={startLabel}
      />
    </Stack>
  );
};

export default ObjectFilterDescription;
